"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var service_definition_1 = require("./../services/service-definition");
var branch_mapping_table_serialiser_1 = require("./../services/session-trees/branch-mapping-table-serialiser");
var session_tree_branch_list_serialiser_1 = require("./../services/session-trees/session-tree-branch-list-serialiser");
exports.PUT_BRANCH_MAPPING_TABLE = {
    id: 176,
    request: branch_mapping_table_serialiser_1.BranchMappingTableSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.GET_SESSION_TREE_BRANCHES_WITH_MAPPINGS = {
    id: 177,
    request: service_definition_1.NullSerialiser,
    response: session_tree_branch_list_serialiser_1.SessionTreeBranchListSerialiser
};
exports.GET_BRANCH_MAPPING_TABLE = {
    id: 178,
    request: string_serialiser_1.StringSerialiser,
    response: branch_mapping_table_serialiser_1.BranchMappingTableSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-trees-services.js
// module id = 1400
// module chunks = 1